import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

const InnerBlock = lazy(() =>
  import('./BookshelfBlock').then(m => ({default: m.BookshelfBlock})),
)

export const bookshelfBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
})

export {useBookshelfConfig} from './hooks'
